module.exports = __webpack_public_path__ + "icon2.png?24a0ea72289a9274d7bfae59b63b1852";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon2.png
// module id = 359
// module chunks = 0